import { EventEmitter, Injectable, Output } from '@angular/core';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { Subscription } from 'rxjs';
import { ChequeMyfileModalComponent } from 'src/app/shared/modals/cheque-myfile-modal/cheque-myfile-modal.component';
import { InvoiceMyfileModalComponent } from 'src/app/shared/modals/invoice-myfile-modal/invoice-myfile-modal.component';
import { MyfileModalComponent } from 'src/app/shared/modals/myfile-modal/myfile-modal.component';
import { TemplateDocumentType } from '../../models/document/document-template-model';
import { MyfileModel } from '../../models/myfile/myfile.model';
import { RequisitionModel } from '../../models/requisition/requisition.model';
import { MyfileApiService } from '../myfile-api.service';

@Injectable({
  providedIn: 'root'
})
export class MyfileModalService {

  @Output() modelChanged = new EventEmitter<any>();

  constructor(
    private modalService: NgbModal,
    private myFileApiService: MyfileApiService
  ) { }

  openModal(model: MyfileModel, requisition: RequisitionModel) {
    var modalRef!: NgbModalRef;
    switch (model.type) {
      case TemplateDocumentType.Invoice:{
        this.myFileApiService.getInvoice(model.id!).subscribe(invoice => {
          if (invoice) {
            modalRef = this.modalService.open(InvoiceMyfileModalComponent, { windowClass: "customModalClassCentered", size: 'lg', centered: true, backdrop: 'static', keyboard: false });
            modalRef.componentInstance.invoice = invoice;
            modalRef.componentInstance.myfile = model;
            modalRef.componentInstance.requisition = requisition;
            var sub: Subscription = modalRef.closed.subscribe(() => {
              this.modelChanged.emit(modalRef.componentInstance.model)
              sub.unsubscribe();
            })
          }
        })
        break;}
      case TemplateDocumentType.Cheque:
        modalRef = this.modalService.open(ChequeMyfileModalComponent, { windowClass: "customModalClassCentered", size: 'lg', centered: true, backdrop: 'static', keyboard: false });
        modalRef.componentInstance.myfile = model;
        modalRef.componentInstance.requisition = requisition;
        var sub: Subscription = modalRef.closed.subscribe(() => {
          this.modelChanged.emit(modalRef.componentInstance.model)
          sub.unsubscribe();
        })
        break;
      default:
        modalRef = this.modalService.open(MyfileModalComponent, { windowClass: "customModalClassCentered", size: 'lg', centered: true, backdrop: 'static', keyboard: false });
        modalRef.componentInstance.myfile = model;
        modalRef.componentInstance.requisition = requisition;
        var sub: Subscription = modalRef.closed.subscribe(() => {
          this.modelChanged.emit(modalRef.componentInstance.model)
          sub.unsubscribe();
        })
        break;
    }
   
  }
}
